import { useServerRenderedProductTiles } from "@faire/retailer-visitor-shared/app/(app)/retailer/[locale]/(pagesWithModal)/(defaultHeader)/search/(treatment)/rsc/_components/ProductTile/ServerRenderedProductTilesContext";
import { shouldShowRscProductTileLoggedInSearchPage } from "@faire/retailer-visitor-shared/settings/getSettingRscProductTileLoggedInSearchPage";
import React from "react";

export const MaybeServerRenderedIrrelevantProductTileWrapper = ({
  index,
  children,
}: {
  index: number;
  children: React.ReactNode;
}) => {
  if (!shouldShowRscProductTileLoggedInSearchPage()) {
    return <>{children}</>;
  }
  return (
    <ServerRenderedIrrelevantProductTileWrapper index={index}>
      {children}
    </ServerRenderedIrrelevantProductTileWrapper>
  );
};

const ServerRenderedIrrelevantProductTileWrapper = ({
  index,
  children,
}: {
  index: number;
  children: React.ReactNode;
}) => {
  // Slot the RSC Product Tile by returning the context value
  // Note that useServerRenderedProductTiles returns an array of RSC Product Tiles
  // If the product tile is not provided for the index, then return the child client tile
  const ServerRenderedIrrelevantProductTile =
    useServerRenderedProductTiles()?.serverRenderedIrrelevantProductTiles?.[
      index
    ];
  return <>{ServerRenderedIrrelevantProductTile ?? children}</>;
};
